import Vue from "vue";
Vue.directive("title", (el, binding) => {
  document.title = binding.value.title || "新能源";
});
